export default {
  'user-login.login.userName': 'userName',
  'user-login.login.password': 'password',
  'user-login.login.message-invalid-credentials':
    'Invalid username or password（admin/ant.design）',
  'user-login.login.message-invalid-verification-code': 'Invalid verification code',
  'user-login.login.tab-login-credentials': 'Credentials',
  'user-login.login.tab-login-mobile': 'Mobile number',
  'user-login.login.remember-me': 'Remember me',
  'user-login.login.forgot-password': 'Forgot your password?',
  'user-login.login.sign-in-with': 'Sign in with',
  'user-login.login.signup': 'Sign up',
  'user-login.login.login': 'Login',
  'user-login.login.verify': "Verify it's you",
  'user-login.register.register': 'Register',
  'user-login.register.get-verification-code': 'Get code',
  'user-login.register.sign-in': 'Already have an account?',
  'user-login.register-result.msg': 'Account：registered at {email}',
  'user-login.register-result.activation-email':
    'The activation email has been sent to your email address and is valid for 24 hours. Please log in to the email in time and click on the link in the email to activate the account.',
  'user-login.register-result.back-home': 'Back to home',
  'user-login.register-result.view-mailbox': 'View mailbox',
  'user-login.email.required': 'Please enter your email!',
  'user-login.email.wrong-format': 'The email address is in the wrong format!',
  'user-login.userName.required': 'Please enter your userName!',
  'user-login.password.required': 'Please enter your password!',
  'user-login.password.twice': 'The passwords entered twice do not match!',
  'user-login.strength.msg':
    "Please enter at least 6 characters and don't use passwords that are easy to guess.",
  'user-login.strength.strong': 'Strength: strong',
  'user-login.strength.medium': 'Strength: medium',
  'user-login.strength.short': 'Strength: too short',
  'user-login.confirm-password.required': 'Please confirm your password!',
  'user-login.phone-number.required': 'Please enter your phone number!',
  'user-login.phone-number.wrong-format': 'Malformed phone number!',
  'user-login.verification-code.required': 'Please enter the verification code!',
  'user-login.title.required': 'Please enter a title',
  'user-login.date.required': 'Please select the start and end date',
  'user-login.goal.required': 'Please enter a description of the goal',
  'user-login.standard.required': 'Please enter a metric',
  'user-login.form.get-captcha': 'Get Captcha',
  'user-login.captcha.second': 'sec',
  'user-login.form.optional': ' (optional) ',
  'user-login.form.submit': 'Submit',
  'user-login.form.save': 'Save',
  'user-login.email.placeholder': 'Email',
  'user-login.password.placeholder': 'Password',
  'user-login.confirm-password.placeholder': 'Confirm password',
  'user-login.phone-number.placeholder': 'Phone number',
  'user-login.verification-code.placeholder': 'Verification code',
  'user-login.title.label': 'Title',
  'user-login.title.placeholder': 'Give the target a name',
  'user-login.date.label': 'Start and end date',
  'user-login.placeholder.start': 'Start date',
  'user-login.placeholder.end': 'End date',
  'user-login.goal.label': 'Goal description',
  'user-login.goal.placeholder': 'Please enter your work goals',
  'user-login.standard.label': 'Metrics',
  'user-login.standard.placeholder': 'Please enter a metric',
  'user-login.client.label': 'Client',
  'user-login.label.tooltip': 'Target service object',
  'user-login.client.placeholder':
    'Please describe your customer service, internal customers directly @ Name / job number',
  'user-login.invites.label': 'Inviting critics',
  'user-login.invites.placeholder':
    'Please direct @ Name / job number, you can invite up to 5 people',
  'user-login.weight.label': 'Weight',
  'user-login.weight.placeholder': 'Please enter weight',
  'user-login.public.label': 'Target disclosure',
  'user-login.label.help': 'Customers and invitees are shared by default',
  'user-login.radio.public': 'Public',
  'user-login.radio.partially-public': 'Partially public',
  'user-login.radio.private': 'Private',
  'user-login.publicUsers.placeholder': 'Open to',
  'user-login.option.A': 'Colleague A',
  'user-login.option.B': 'Colleague B',
  'user-login.option.C': 'Colleague C',
  'user-login.navBar.lang': 'Languages',
};
